// utils/auth.js

// Key for storing token in localStorage
const TOKEN_KEY = "authToken";

/**
 * Save token to localStorage
 * @param {string} token - JWT token string
 */
export const saveToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

/**
 * Get token from localStorage
 * @returns {string|null} - JWT token if exists, else null
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Remove token from localStorage (logout)
 */
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};
/**
 * Verify if JWT is valid (checks expiration)
 * @returns {boolean} true if valid, false otherwise
 */
export const isTokenValid = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Date.now() / 1000; // in seconds
    return payload.exp && payload.exp > currentTime;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};
